import React, { useMemo, useState, useRef, useEffect } from "react";
import womenImg from "../../../../asset/images/ibaimages/womenImg.svg";
import searchIba from "../../../../asset/images/ibaimages/searchIba.svg";
import backDetails from "../../../../asset/images/ibaimages/backDetails.svg";
import LoaderForSearch from "../../../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";


import { useAgents } from "../../hooks/useAgents";
import { getInitials } from "../../../../CommonMethhods/CommonMethods";

const IbaHoldPayout = ({ setShowHoldpayout, refreshActiveAgents, handleApprove }) => {
  const searchBoxRef = useRef(null);

  const [newlyAddedAgentIds, setNewlyAddedAgentIds] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedAgents, setSelectedAgents] = useState([]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(searchTerm);
  }, 1000);

  return () => clearTimeout(timer);
}, [searchTerm]);

useEffect(() => {
  if (debouncedSearch !== "") {
    handleSearch(debouncedSearch);
  }
}, [debouncedSearch]);

  const {
    agents: agentsToHold,
    setAgents: setAgentsToHold,
    loading: loadingHeld,
    scrollLoading: scrollLoaderTable,
    handleScroll: handleHeldScroll,
    fetchAgents: fetchHeldAgents,
  } = useAgents({ status: 4, limit: 10 });

  //Search agents (status = 3)
  const {
    agents: searchAgents,
    loading: searchLoading,
    scrollLoading: scrollLoaderSearch,
    handleScroll: handleSearchScroll,
    handleSearch,
  } = useAgents({ status: 3, limit: 5 });

  const agentIdSet = useMemo(
  () => new Set(agentsToHold?.map((a) => a.TelecallerId)),
  [agentsToHold]
);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onSearchChange = (value) => {
    setSearchTerm(value);
  //   setAgentsToHold([]);
  // setNewlyAddedAgentIds(new Set());

  // handleSearch(value);
  };

  // const handleCheckboxChange = (agent) => {
  //   const alreadyExists = agentIdSet.has(agent.TelecallerId);

  //   if (alreadyExists) {
  //     setAgentsToHold((prev) => prev.filter((a) => a.TelecallerId  !== agent.TelecallerId ));
  //     setNewlyAddedAgentIds((prev) => {
  //       const updated = new Set(prev);
  //       updated.delete(agent.TelecallerId );
  //       return updated;
  //     });
  //   } else {
  //     setSelectedAgents((prev) => [...prev, agent]);
  //     // setAgentsToHold((prev) => [...prev, agent]);
  //     setNewlyAddedAgentIds((prev) => new Set(prev).add(agent.TelecallerId));
  //   }
  // };

  const selectedIdSet = useMemo(() => {
  return new Set(
    selectedAgents.map((a) => a.TelecallerId)
  );
}, [selectedAgents]);

  const handleCheckboxChange = (agent) => {
  const alreadyExists = selectedIdSet.has(agent.TelecallerId);

  if (alreadyExists) {
    setSelectedAgents((prev) =>
      prev.filter((a) => a.TelecallerId !== agent.TelecallerId)
    );
  } else {
    setSelectedAgents((prev) => [...prev, agent]);
  }
};

  const handlePasteInput = () => (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");

        let clean = pastedText.toUpperCase().replace(/[^A-Z0-9\s]/g, "")
        clean = clean.replace(/\s+/g, " ").trim();
        if (clean === "") return;

        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = input.value;

        const newValue = (
            currentValue.slice(0, start) +
            clean +
            currentValue.slice(end)
        ).slice(0, 15);
        setSearchTerm(newValue)
        
        input.value = newValue;
        const cursorPos = start + clean.length;
        setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
    };

    const tableAgents = useMemo(() => {
  const combined = [...agentsToHold, ...selectedAgents];

  return combined.filter(
    (agent, index, self) =>
      index ===
      self.findIndex(
        (a) => a.TelecallerId === agent.TelecallerId
      )
  );
}, [agentsToHold, selectedAgents]);
  

  return (
    <main id="main-content" className="telecallerDash iba-page">
      <div className="agent-table-wrapper mb-3">
        <div className="header-agent mb-5">
          <img
            style={{ cursor: "pointer" }}
            src={backDetails}
            alt="backDetails"
            onClick={() => {
              setShowHoldpayout(false);
              refreshActiveAgents();
            }}
          />
          <h2>Hold Payout</h2>
        </div>

        <div className="mb-5">
          <span className="search-label">Select Agent to Hold Payout:</span>
          <div className="wrap-search">
          <div className="search-bar search-hold">
            <img src={searchIba} alt="searchIba" />
            <input
              type="text"
              placeholder="Enter Agent Name or ID"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-100"
              maxLength={15}
              onInput={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;
                let input = e.target.value;
                input = input
                    .toUpperCase()
                    .replace(/[^A-Z0-9\s]/g, "")
                    .replace(/\s+/g, " ")
                    .trimStart()
                    .slice(0, 15);
                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
              onPaste={handlePasteInput}
            />
          </div>

          {searchTerm && (
            <div
              className="iba-search-box"
              style={{ maxHeight: "150px", overflowY: "auto", scrollbarWidth: "none"}}
              onScroll={handleSearchScroll}
              ref={searchBoxRef}
            >
              {searchLoading ? (
                <div className="d-flex justify-content-center">
                  <LoaderForSearch />
                </div>
              ) : searchAgents?.length > 0 ? (
                searchAgents.map((agent) => (
                  <div
                    key={agent?.id}
                    className="d-flex align-items-center justify-content-between p-3 dropdown-list"
                  >
                    <div className="d-flex w-100 pr-3 dropdown-wrap">
                      <div className="dropdown-text">
                        {agent?.IBAName}
                      </div>
                      <div className="dropdoen-id">
                        {agent?.TelecallerId}
                      </div>
                    </div>

                    <input
                      type="checkbox"
                      checked={selectedIdSet.has(agent.TelecallerId)}
                      // checked={agentIdSet.has(agent.TelecallerId)}
                      onChange={() => handleCheckboxChange(agent)}
                    />
                  </div>
                ))
              ) : (
                <div style={{ fontSize: "12px" }} className="p-3">
                  No agents found
                </div>
              )}
              {scrollLoaderSearch && (
                <div className="d-flex justify-content-center">
                  <LoaderForSearch />
                </div>
              )}
            </div>
          )}
          </div>
        </div>

        {/* 🔹 Held agents table */}
        <table className="agent-table">
          <thead>
            <tr>
              <th>Agent Name</th>
              <th>Talktime (min)</th>
              <th>Accounts Opened</th>
              <th>Total Payout</th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody onScroll={handleHeldScroll}>
            {loadingHeld ? (
              <tr>
                <td colSpan="5" className="text-center">
                  <div className="d-flex justify-content-center">
                    <LoaderForSearch />
                  </div>
                </td>
              </tr>
            ) : agentsToHold?.length > 0 ? (
              tableAgents.map((agent) => (
                <tr key={agent.TelecallerId}>
                  <td className="name-cell">
                    <div className='show-initial avatar-text'>
                      <span className='init-text'>{getInitials(agent?.IBAName || "N/A")}</span>
                  </div>
                    {/* <img src={womenImg} alt="avatar" className="avatar" /> */}
                    {agent?.IBAName}
                  </td>
                  <td>{agent?.TotalTalktime}</td>
                  <td>{agent?.AccountsOpened}</td>
                  <td>{agent?.TotalPayout}</td>
                </tr>
              )
            )
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No agents found
                </td>
              </tr>
            )}
            {scrollLoaderTable && (
              <tr>
                <td colSpan="5" className="text-center">
                  <div className="d-flex justify-content-center">
                    <LoaderForSearch />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* {newlyAddedAgentIds.size > 0 && !loadingHeld && ( */}
        {selectedAgents.length > 0 && !loadingHeld && (
          <button className="approve-btn mr-3 mt-3" 
          onClick={() =>
            handleApprove(
              "hold",
              [...agentsToHold, ...selectedAgents]
            )
          }
          // onClick={()=> handleApprove("hold".toLowerCase(), agentsToHold)}
          >
            Hold Payout
          </button>
        )}
      </div>
    </main>
  );
};

export default IbaHoldPayout;
